import { selectAppConfig } from "./selectAppConfig";

export const selectDebugData = state => selectAppConfig(state).debug;

